import { useParams } from "react-router-dom"

import PageNotFound from "../../common/404"
import CandidateDetails from "../candidate-details"

export default function LeadDetailsPage() {
  const { leadSource, id } = useParams()
  if (leadSource !== "mls" && leadSource !== "uploaded") {
    return <PageNotFound />
  }
  return <CandidateDetails leadMode={{ source: leadSource, id }} />
}
